import { render, staticRenderFns } from "./Usps.vue?vue&type=template&id=15667ead&scoped=true"
import script from "./Usps.vue?vue&type=script&lang=js"
export * from "./Usps.vue?vue&type=script&lang=js"
import style0 from "./Usps.vue?vue&type=style&index=0&id=15667ead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15667ead",
  null
  
)

export default component.exports